const Google = () => {
  return (
    <div>
      <h1>Google Workspace Integration</h1>
    </div>
  )
}

export default Google